import { PlayerAhoyEvent } from '../../player_ahoy_event';
import nodelistToArray from '../../utils/nodelist_to_array';
import OffSubtitleItem from './off_subtitle_item';
import TrackSubtitleItem from './track_subtitle_item';
import isFeatureToggleOn from "../../utils/feature_toggle";

export default class SubtitleList {
  constructor(player, options = {}){
    this.options_ = options;
    this.player = player;
    this._el = document.createElement("div");
    this._el.className = "vjs-subtitle-switcher__container";
  }

  videoId() {
    return this.options_.videoId;
  }

  play_uuid() {
    return this.options_.play_uuid;
  }

  textTracks() {
    return nodelistToArray(this.player.textTracks()).filter((track) => {
      return !this.isMetadata(track);
    });
  }

  createList() {
    const ul = document.createElement("ul");
    ul.setAttribute('role', 'menu');
    ul.classList.add("vjs-subtitle-switcher__list");
    return ul;
  }

  el(){
    return this._el;
  }

  handleTrackChange(event) {
    const selectedTrack = event.detail;

    // need to filter textTracks by kind because textTracks will have double textTracks one from data-subtitle and one from master playlist, track.kind is the flag to differentiate it.
    const enable_from_master_playlist = isFeatureToggleOn('enable_subtitle_from_master_playlist');
    const selectedKind = enable_from_master_playlist ? "subtitles" : "captions";

    for (const t of this.textTracks()) {
      if (t.label === selectedTrack.label && t.kind === selectedKind) {
        if (t.mode === 'disabled' || t.mode === 'hidden') {
          t.mode = 'showing';
        }

      // If this text track is not the component's track and it is not
      // disabled, set it to disabled.
      } else if (t.mode === 'showing') {
        t.mode = 'disabled';
      }
    }
    
    this.triggerEventChange(event.detail.label.toLowerCase());
    PlayerAhoyEvent.sendSubtitle({
      action: 'select',
      subtitle: event.detail.label,
      video_id: this.videoId(),
      play_uuid: this.play_uuid()
    });
  }

  handleSubtitleOff() {
    for (const t of this.textTracks()) {
      if (t.mode === 'showing') {
        t.mode = 'disabled';
      }
    }
  }

  setEl(){
    var ul = this.createList();
    let player = this.player;

    this.el().addEventListener('subtitleTrackClick', (e) => this.handleTrackChange(e), false)
    this.el().addEventListener('subtitleOffClick', (e) => this.handleSubtitleOff(), false)

    this.textTracks().forEach((track) => {
      var enable_from_master_playlist = isFeatureToggleOn('enable_subtitle_from_master_playlist');
      var selectedKind = enable_from_master_playlist ? "subtitles" : "captions";

      if (track.kind == selectedKind) {
        var listItem = new TrackSubtitleItem({player, track});
        listItem.updateActiveStatus();
        ul.appendChild(listItem.el());
      }
    });
    var offButton = new OffSubtitleItem({player});
    offButton.updateActiveStatus();
    ul.appendChild(offButton.el());
    this.el().appendChild(ul);
    this.bindFocusOut();
  }

  show(){
    this.el().style.display = "block";
    this.el().querySelector('ul li').focus();
    this.checkPlayerInactive();
  }

  hide(){
    this.el().style.display = "none";
  }

  hideIfOutside(e){
    if (!document.querySelector('.vjs-subtitle-switcher').contains(e.target)) {
      this.hide();
    }
  }

  bindFocusOut(){
    document.addEventListener('click', this.hideIfOutside.bind(this));
    document.addEventListener('touchend', this.hideIfOutside.bind(this));
    this.player.on('vp-episodes-list-open', this.hide.bind(this));
  }

  displayStatus(){
    return getComputedStyle(this.el()).display;
  }

  toggle(){
    if (this.displayStatus() == "none") {
      this.show();
      this.triggerEventClick();
    } else {
      this.hide();
    }
  }

  checkPlayerInactive() {
    const element = document.querySelector('.video-js');
    const controlBar = document.querySelector('.vjs-progress-control');

    const interval = setInterval(() => {
      if (element.classList.contains('vjs-user-inactive') && !element.classList.contains('vjs-paused')) {
        clearInterval(interval);
        // Ada bug di sini. Flaky kadang ketika ganti2 subtitle progress bar nya nggak muncul
        controlBar.classList.remove('vjs-progress-control--hidden');
        this.hide();
      }
    }, 100);
  }

  isMetadata(track) {
    return track.label == 'segment-metadata';
  }

  triggerEventChange(selectedTrack){
    this.player.trigger({type: "vp-subtitle-change", id: this.options_.videoId, track: selectedTrack});
  }

  triggerEventClick(){
    this.player.trigger({type: "vp-subtitle-click", id: this.options_.videoId});
  }
}
